/**
 * @Author: KOC Apps Admin <kocappsadmin>
 * @Date:   2018-04-25T02:36:18+03:00
 * @Email:  admin@kocapps.com
 * @Filename: load.js
 * @Last modified by:   keremkoc
 * @Last modified time: 2018-06-09T19:17:29+03:00
 */

//we load remote data and set current screen here!

(function($, root) {

  $.loadPage = function() {
    $.hideIntro().done(function() {
      $.queryContent();
      $('body').addClass('show-content');
      $('header').fadeIn();
      window.rdo.loader.introdone = true;

      $.onresizeWithTimeout(function() {
        // $('#vertical-timeline').getInitialScrollPositions('.sitem', '#vertical-timeline .wrapper');
        $.vidRescale();

      });
    });
  };

  $.queryContent = function(content) {

    // window.rdo.slug
    //   window.rdo.type
    // console.log('current content is:');
    let found = false;
    let yr = 0;
    let sb = 0;
    let ct = 0;

    for (let iy = 0; iy < window.rdo.data.years.length; iy++) {
      let year = window.rdo.data.years[iy];
      // console.log(year);

      // for (let subject of year.subjects) {
      for (let is = 0; is < year.subjects.length; is++) {
        let subject = year.subjects[is];
        if (window.rdo.type == 'konu') {
          if (subject.slug == window.rdo.slug) {
            found = true;
            yr = year.index;
            sb = is;
          }

        } else {
          for (let ic = 0; ic < subject.contents.length; ic++) {
            let content = subject.contents[ic];
            // console.log(window.rdo.slug);
            if (content.slug == window.rdo.slug) {
              // console.log('found content');
              // console.log(content.slug);
              found = true;
              yr = year.index;
              sb = is;
              ct = ic + 1;
            }
            if (found) {
              break;
            }
          }

        }

        if (found) {
          break;
        }
        // is++;

      }

      if (found) {
        // console.log('lets go to: ' + yr + ' su:' + sb + ' co:' + ct);
        $.selectYear(yr, sb, ct);
        break;
      }

    }

    // $.selectYear(0, 0, 0); // $.ajax({
    //   type: "POST",
    //   url: window.rdo.queryContent,
    //   // + window.rdo.pages[window.rdo.currentpage].url,
    //   // calltimeout: window.rdo.loader.requesttimeout,
    //   data: content,
    //   dataType: 'text',
    //   success: function(data) {
    //     console.log('success in data load');
    //     console.log(data);
    //     // window.rdo.data = JSON.parse(data).content;
    //     // console.log(window.rdo.data)
    //     // $.views.helpers({
    //     //   all: window.rdo.data
    //     // });
    //     // deferred.resolve();
    //
    //   },
    //   fail: function(data) {
    //     console.log('fail in data load');
    //     // deferred.resolve();
    //
    //   }
    // });
  }

  $.getCurrentPath = function() {
    // window.rdo.type = null;
    // console.log('path name is ' + window.location.pathname);
    window.rdo.pathname = window.location.pathname;
    // let path = window.rdo.url;
    if (window.rdo.pathname.toString().indexOf('/icerik/') !== -1) {
      // console.log('type icerik');
      window.rdo.slug = window.rdo.pathname.toString().replace(/^.*?\/icerik\//, '') || null;

      window.rdo.slug = window.rdo.slug.slice(0, -1);
      window.rdo.type = 'icerik';
      // console.log(window.rdo.slug);

    } else if (window.rdo.pathname.toString().indexOf('/konu/') !== -1) {
      // console.log('type konu');

      window.rdo.slug = window.rdo.pathname.toString().replace(/^.*?\/konu\//, '') || null;
      window.rdo.slug = window.rdo.slug.slice(0, -1);
      // console.log(window.rdo.slug);
      window.rdo.type = 'konu';

    } else {
      window.rdo.type = 'main';

    }

    // console.log('current path');
    // console.log(window.rdo.slug);

    // console.log('current content');

  };

  $.changePagePath = function(page) {
    let url = window.location.origin;
    // document.location.toString().match(/^(.*?)#/);

    // if (url) {
    //   url = url[1];
    // } else {
    //   url = document.location.toString();
    // }
    let title = window.rdo.sitetitle + ' - ' + window.rdo.data.selected.year.year + ' - ' + window.rdo.data.selected.content.post_title;

    if (window.rdo.data.selected.content.subject) {
      url = url + '/konu/';
      // url = url + window.rdo.data.selected.content.slug;

    } else {
      url = url + '/icerik/';

    }
    url = url + window.rdo.data.selected.content.slug;
    $(document).prop('title', title);

    // console.log('changing path');
    // console.log(url);
    window.history.replaceState({}, document.title, url);

    window.rdo.data.selected.content.pageinfo = {
      url: encodeURI(url),
      title: encodeURI(title),
      summary: encodeURI(window.rdo.data.selected.content.description),
      source: encodeURI(window.location.origin)
    };
    // {{urlencode pageinfo.url /}}
    // {
    //  currentpage.url = url;
    //  window.rdo.currentpage.title = title;

    // window.location.href = url;
  };

  $.preloadContent = function(content, type) {

    var deferred = $.Deferred();
    window.rdo.preloadCompleted = false;
    window.rdo.numpreloads = 0;
    window.rdo.requiredpreloads = 0;

    if (content.background_sound) {
      $.preloadAudio(content.background_sound.url).done(function() {
        $.checkAllPreloadDone(deferred);
      });
    }

    if (content.audio) {
      $.preloadAudio(content.audio.url, false).done(function() {
        $.checkAllPreloadDone(deferred);
      });
    }
    //
    if (content.short_audio, false) {
      $.preloadAudio(content.short_audio.url).done(function() {
        $.checkAllPreloadDone(deferred);
      });
    }

    if (content.thumbnail) {

      $.preloadImage(content.thumbnail).done(function() {
        $.checkAllPreloadDone(deferred);
      });
    } else if (content.background_video) {
      $.preloadVideo(content.background_video).done(function() {
        $.checkAllPreloadDone(deferred);
      });
    } else {
      $.checkAllPreloadDone(deferred);
    }

    return deferred.promise();
  }

  $.checkAllPreloadDone = function(deferred) {

    // setTimeout(function() {

    if (window.rdo.numpreloads == window.rdo.requiredpreloads) {
      // console.log('all ' + window.rdo.numpreloads + ' /' + window.rdo.requiredpreloads + ' are preloaded!!!');
      window.rdo.preloading == 'next';
      window.rdo.preloadCompleted = true;
      deferred.resolve();
    } else {
      // console.log(window.rdo.numpreloads + ' /' + window.rdo.requiredpreloads + ' preloaded....');
    }
    // }, window.rdo.transitions.transition*30);
  }

  $.preloadImage = function(src) {
    window.rdo.requiredpreloads++;
    // console.log('bg image file' + src + ' is preloading...');
    var deferred = $.Deferred();
    let image = new Image();

    image.onload = function() {
      // console.log('bg image file' + src + ' is preloaded!!!');
      window.rdo.numpreloads++;
      deferred.resolve();
    };

    image.src = src;
    return deferred.promise();
  }

  $.preloadVideo = function(src) {
    window.rdo.requiredpreloads++;
    var deferred = $.Deferred();
    // console.log('bg video file' + src + ' is preloading...');

    if (1) {
      // console.log('bg video file' + src + ' is preloaded!!!');
      window.rdo.numpreloads++;
      deferred.resolve();
    }
    return deferred.promise();
  }

  $.preloadAudio = function(src, wait) {
    wait = wait || true;
      var deferred = $.Deferred();
    if (!window.rdo.isMobile) {

      if (wait) {
        window.rdo.requiredpreloads++;
      }
      // console.log('bg audio file' + src + ' is preloading...');

      var audio = new Audio();

      audio.addEventListener('canplaythrough', function(wait) {
        // console.log('bg audio file' + src + ' is preloaded!!!');
        if (wait) {
          window.rdo.numpreloads++;
        }
        deferred.resolve();
      }, false);

      audio.src = src;
    } else {
      deferred.resolve();

    }

    return deferred.promise();
  }

  $.waitUntilPreload = function() {
    $.pauseTimer();
    $.showSpinner();

    // console.log('wait until preloaded');

    window.rdo.preloadStatus.done(function() {
      // console.log(' preload is just completed! :');
      if (window.rdo.preloading == 'next') {
        $.continueTimer();
        $.moveNextContent();

      } else if (window.rdo.preloading == 'this') {
        $.continueTimer();
        $.renderContent();
        window.rdo.preloading = 'next';
        window.rdo.preloadStatus = $.preloadContent(window.rdo.data.next.content, 'next');

      }

    });
  }

  // $.getCurrentPage = function() {
  //   if (document.location.toString().indexOf('#') !== -1) {
  //     window.rdo.currentpage = document.location.toString().replace(/^.*?#/, '') || window.rdo.pages.defaultpage;
  //   } else {
  //     window.rdo.currentpage = window.rdo.pages.defaultpage;
  //   }
  //
  // };
  //
  // $.changePagePath = function(page) {
  //   let url = document.location.toString().match(/^(.*?)#/);
  //
  //   if (url) {
  //     url = url[1];
  //   } else {
  //     url = document.location.toString();
  //   }
  //
  //   window.location.href = url + '#' + page;
  // };

  $.loadPageData = function(option) {
    option = option || false;

    var deferred = $.Deferred();
    // console.log(window.rdo.currentpage);
    // if ("undefined" !== typeof(window.rdo.pages[window.rdo.currentpage].url) && window.rdo.mode == 'service') {
    $.ajax({
      type: "GET",
      url: window.rdo.service,
      // + window.rdo.pages[window.rdo.currentpage].url,
      // calltimeout: window.rdo.loader.requesttimeout,
      // data: {
      //   'option': option
      // },
      dataType: 'text',
      success: function(data) {
        // console.log('success in data load');
        window.rdo.data = JSON.parse(data).content;
        console.log(window.rdo.data)
        $.views.helpers({
          all: window.rdo.data
        });
        deferred.resolve();

      },
      fail: function(data) {
        // console.log('fail in data load');
        deferred.resolve();

      }
    });

    // } else if (window.rdo.mode == 'dummydata' && window.rdo.pages[window.rdo.currentpage].class !== 'video') {
    //
    //   // console.log(window.alldata);
    //   window.rdo.data = window.alldata[window.rdo.currentpage];
    //   deferred.resolve();
    //   // $.getJSON('./dummydata/' + window.rdo.currentpage + '.json', function(json) {
    //   //   window.rdo.data = json;
    //   //   deferred.resolve();
    //   // });
    //
    //   // $.ajax({
    //   //   type: "GET",
    //   //   url: './dummydata/' + window.rdo.currentpage + '.json',
    //   //   calltimeout: window.rdo.requesttimeout,
    //   //   // data: {
    //   //   //   'option': option
    //   //   // },
    //   //   dataType: 'text',
    //   //   success: function(data) {
    //   //     console.log('success in data load');
    //   //     window.rdo.data = JSON.parse(data);
    //   //     deferred.resolve();
    //   //
    //   //   },
    //   //   fail: function(data) {
    //   //     console.log('fail in data load');
    //   //     deferred.resolve();
    //   //
    //   //   }
    //   // });
    //
    // } else {
    //   window.rdo.data = null;
    //   deferred.resolve();
    //
    // }

    return deferred.promise();

  };
})(jQuery, this);
